
import './App.css';
import PrincipalComponent from './components/PrincipalComponent';

function App() {
  return (
    <div>
      <PrincipalComponent/>
    </div>
  );
}

export default App;
